



































































import { BulletinDeSalaire } from "../../models/BulletinDeSalaire";
import moment from "moment";
import NumeralInput from "../../core/Forms/NumeraInput.vue";
import EmployeSelect from "../../core/Forms/EmployeSelect.vue";

export default {
    name: "BulletinDeSalaireModalEdit",
    components: { EmployeSelect, NumeralInput },
    props: {
        bulletinDeSalaire: BulletinDeSalaire,
    },
    data() {
        return {
            month: null,
        };
    },
    created() {
        this.initDates();
    },
    methods: {
        initDates() {
            if (this.bulletinDeSalaire.month) {
                this.month = new Date(this.bulletinDeSalaire.month);
            }
        },
        updateMonth(date) {
            this.bulletinDeSalaire.month = moment(date)
                .startOf("month")
                .format("YYYY-MM-DD");
        },
    },
    watch: {
        bulletinDeSalaire: {
            immediate: true,
            handler() {
                this.initDates();
            },
        },
    },
};
